import React, {ChangeEvent, ReactNode, RefObject, useCallback, useState} from 'react';
import {Input} from '@priority-software/priority-style-react';
import {getInputDirection} from '../../../../../Form/common/getInputDirections';

type Props = {
    onChange: (val: string, name: string) => void;
    defaultValue: string;
    placeholder?: string;
    componentClasses?: string;
    name?: string;
    children?: ReactNode;
    inputRef?: RefObject<HTMLInputElement>;
    size?: 'large' | 'medium';
    maxChars?: number;
};

const direction = getInputDirection();

export const InputControl = (props: Props) => {
    const {
        onChange,
        defaultValue,
        placeholder,
        componentClasses,
        name,
        children,
        maxChars,
        inputRef,
        size
    } = props;
    const [value, setValue] = useState(defaultValue || '');

    const handleChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const eventValue = e.target.value;

            const validatedValue =
                maxChars && eventValue.length > maxChars
                    ? eventValue.slice(0, maxChars)
                    : eventValue;
            setValue(validatedValue);
            onChange(validatedValue, name);
        },
        [onChange, name, maxChars]
    );

    return (
        <Input
            inputRef={inputRef}
            name={name}
            size={size}
            componentClasses={componentClasses}
            value={value}
            placeholder={placeholder}
            onChange={handleChange}
            direction={direction}
        >
            {children}
        </Input>
    );
};
